<template>
  <div style="position: relative;">
    <div :id="`mycharts-${name}`" class="mycharts" style="height: 16rem;width: 24rem;z-index: 800;position: relative;"></div>
    <a class="delete-div" @click="setShowChart"></a>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: {
    name: String,
    data: Object,
    option: Object
  },
  watch: {
    data(val, oldVal) {
      this.showChart = true
      if (val.current === '' || !val.waterPressure === '') {
        return
      }
      if (this.chartData.current.length > 999) {
        this.chartData.current.shift()
        this.chartData.current.push(val.current)
      } else {
        this.chartData.current.push(val.current)
      }

      if (this.chartData.waterPressure.length > 999) {
        this.chartData.waterPressure.shift()
        this.chartData.waterPressure.push(val.waterPressure)
      } else {
        this.chartData.waterPressure.push(val.waterPressure)
      }

      let timer = setTimeout(() => {
        if (!this.befor) {
          this.befor = new Date().getTime()
        } else {
          const now = new Date().getTime()
          if (now - this.befor < 1000) {
            clearTimeout(timer)
          } else {
            this.options.series[0].data = this.chartData.current
            this.options.series[1].data = this.chartData.waterPressure
            this.myChart.setOption(this.options)
            this.befor = now
          }
        }
      }, 1000)
    },
    option(val, oldVal) {
      this.showChart = true
      this.options.title.text = val.title
      this.myChart.setOption(this.options)
    }
  },
  data() {
    return {
      showChart: true,
      chartData: {
        current: [],
        waterPressure: []
      },
      options: {
        title: {
          top: 3,
          text: this.option.title,
          textStyle: {
            color: 'rgb(255, 255, 255)',
            fontSize: 13,
            lineHeight: 0
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend:{
          top: 16,
          padding: 0,
          height: 10,
          textStyle: {
            color: 'rgb(255, 255, 255)',
            fontSize: 10,
            lineHeight: 0
          }
        },
        xAxis: {
          type: 'time',
          axisLabel: {
            color: 'rgb(255, 255, 255)'
          }
        },
        yAxis: [
          {
            name: '电流(A)',
            type: 'value',
            axisLabel: {
              color: 'rgb(255, 255, 255)'
            },
            splitLine: {
              show: false
            }
          },
          {
            name: '水压(bar)',
            type: 'value',
            axisLabel: {
              color: 'rgb(255, 255, 255)'
            },
            splitLine: {
              show: false
            }
          }
        ],
        grid: {
          top: '50',
          bottom: '14%'
        },
        series: [
          {
            name: '电流',
            type: 'line',
            showSymbol: false,
            smooth: true,
            lineStyle: {width:1},
            data: []
          },
          {
            yAxisIndex: 1,
            name: '水压',
            type: 'line',
            showSymbol: false,
            smooth: true,
            lineStyle: {width:1},
            data: []
          }
        ]
      },
      myChart: ''
    }
  },
  mounted() {
    let chartDom = document.getElementById(`mycharts-${this.name}`)
    this.myChart = echarts.init(chartDom)
    this.myChart.setOption(this.options)
  },
  methods: {
    setShowChart() {
      if (this.showChart) {
        this.showChart = false
        this.$emit('onClose', false);
      }
    },
    clearData() {
      this.options.series[0].data.length = 0
      this.options.series[1].data.length = 0
      this.myChart.setOption(this.options)
    }
  }
}
</script>

<style>
.mycharts {
  margin-left: 1rem;
  position: relative;
  border: 1px solid #17366c;
  background: linear-gradient(to left, #3897cf, #3897cf) left top no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) left top no-repeat, linear-gradient(to left, #3897cf, #3897cf) right top no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) right top no-repeat, linear-gradient(to left, #3897cf, #3897cf) left bottom no-repeat, linear-gradient(to bottom, #3897cf, #3897cf) left bottom no-repeat, linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat, linear-gradient(to left, #3897cf, #3897cf) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  background-color: rgba(14, 8, 97, 0.418);
}
.delete-div {
  z-index: 801;
  top: 0.8rem;
  right: 0.8rem;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: "Helvetica Neue", Helvetica, Tahoma, Arial, "Microsoft Yahei", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  pointer-events: auto;
  line-height: initial;
  box-sizing: border-box;
  background-color: transparent;
  display: inline-block;
  vertical-align: top;
  position: absolute;
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url("../../../static/mapconfig/img/close-1.svg");
  background-size: 1.2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/TimeLineChart.vue